import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from "recharts";
import svg62 from "../../../assets/svg/svg62.svg";
import { useSelector } from "react-redux";

 
const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
      fontSize="12"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

function Programmes() {
  const url = "api/v2/dashboard/getProjectDashboardData";
  const { loading,  count,data } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],     
    count: state.fetch.count[url] || 0,    
  }));

  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white   w-full h-full">
      <div className="flex items-center justify-between text-[#424242] font-interSans text-[.75rem] font-[500] mb-[1.18rem]">
        <div className="flex items-center gap-x-[.65rem]">
          <span className="">Project Programs</span>
          <img src={svg62} alt="svg62" />
        </div>
      </div>

      <ResponsiveContainer width="100%" height={230}>
        <PieChart>
          <Pie
            data={data?.projectPrograms}
            cx="50%"
            cy="45%"
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
          >
            {data?.projectPrograms?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry?.color} />
            ))}
          </Pie>
          {/* <Legend
            layout="horizontal"
            verticalAlign="bottom"
            align="start"
            iconType="circle"
            height={36}
          /> */}
        </PieChart>
      </ResponsiveContainer>

      <div className="flex flex-wrap gap-[.75rem] mt-0">
  {data?.projectPrograms?.map((entry, index) => (
    <div key={index} className="flex items-center gap-x-2  font-[400] text-[#1A1A1A] font-interSans text-[.75rem] ">
      <span
        className="inline-block w-3 h-3 rounded-full"
        style={{ backgroundColor: entry?.color }}
      ></span>
      <span>{entry?.program_name}</span>
    </div>
  ))}
</div>

    </div>
  );
}

export default Programmes;
